export default __webpack_public_path__ + "static/media/landscape13.2173b0f3.jpg";